import { render, staticRenderFns } from "./geofence-detail.vue?vue&type=template&id=42e0f957&"
import script from "./geofence-detail.vue?vue&type=script&lang=js&"
export * from "./geofence-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports